import styled from "styled-components";

const Required = styled.span.attrs({
    children: ''
})`
    color: currentColor;
`;

export default Required;